import { useRouteInfo } from '@/hooks/useRouteInfo';
import { useTargetStartAt } from '@/hooks/useTargetStartAt';
import { PrevNextPeriodNavigation } from './PrevNextPeriodNavigation';
import { TodayNavigation } from './TodayNavigation';

export function LeftNav() {
  const { periodParam: period, targetDateParam } = useRouteInfo();
  const targetStartAtResult = useTargetStartAt(period, targetDateParam);

  if (!targetStartAtResult) {
    return null;
  }

  const { startAt } = targetStartAtResult;

  return (
    <div className="flex items-center gap-1.5">
      <TodayNavigation />
      <PrevNextPeriodNavigation targetStartAt={startAt} period={period} />
    </div>
  );
}
